import { type Context, type Plugin } from '@segment/analytics-next'
import { SEGMENT_BRAND, SEGMENT_DEPLOYABLE_NAME, segmentAdsTimestamps } from '@nwwp/utils'

export const defaultParametersPlugin = (): Plugin => {
  return {
    name: 'default-parameters',
    type: 'enrichment',

    isLoaded: () => true,
    load: () => Promise.resolve(),

    page: (ctx) => {
      applyDefaultParameters(ctx)
      return ctx
    },

    track: (ctx) => {
      applyDefaultParameters(ctx)
      return ctx
    },
  }
}

const applyDefaultParameters = (ctx: Context) => {
  const { ads_timestamp, ads_timestamp_unix } = segmentAdsTimestamps()
  ctx.updateEvent('properties.deployable_name', SEGMENT_DEPLOYABLE_NAME)
  ctx.updateEvent('properties.deployable_version', '1.0.0')

  const existingAA = {
    ...((ctx.event.properties?.additional_attributes as Record<string, unknown> | undefined) ?? {}),
  }
  ctx.updateEvent('properties.additional_attributes', {
    ...existingAA,
    brand: SEGMENT_BRAND,
    segment_source: 'browser',
    ads_timestamp,
    ads_timestamp_unix,
  })
}
